import ResetPassword from '@/common/containers/Forms/ResetPassword/ResetPassword';

export default ResetPassword;
